<template>
  <a-spin :spinning="confirmLoading">
      <a-tabs @change="changeTabs" default-active-key="1" size="large" :tab-bar-style="{marginBottom: '24px', paddingLeft: '16px'}" >
        <a-tab-pane loading="true" :tab="tabName1" key="1">
          <j-form-container >
            <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
                <a-form-model-item :label="language['application.applicationCode']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="applicationCode">
                  <a-input v-model="model.applicationCode"  max-Length="64" :disabled="formDisabled"></a-input>
                </a-form-model-item>
                <a-form-model-item :label="language['application.applicationName']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="applicationName">
                  <a-input v-model="model.applicationName"  max-Length="64" style="width: 85%" :disabled="formDisabled"></a-input>
                  <a-button @click="languageModelOpen('SysBmApplication','applicationName',applicationNameLanguages)" type="primary"  style="left: 3%" :disabled="false">{{language['common.language']}}</a-button>
                </a-form-model-item>
                <a-form-model-item :label="language['application.applicationDesc']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="applicationDesc">
                  <!--<a-input v-model="model.applicationDesc"  max-Length="255"></a-input>-->
                  <a-textarea v-model="model.applicationDesc"  :maxLength="255" style="width: 85%" :disabled="formDisabled"></a-textarea>
                  <a-button @click="languageModelOpen('SysBmApplication','applicationDesc',applicationDescLanguages)" type="primary"  style="left: 3%" >{{language['common.language']}}</a-button>
                </a-form-model-item>

              <!--新增栏位-->
               <!--主要功能-->
              <a-form-model-item  :label="this.language['portal.ui2.appMajorFunction']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="functionDesc">
                <a-textarea v-model="model.functionDesc" :placeholder="this.language['portal.ui2.appMajorFunction.desc']"   style="width: 85%" :disabled="formDisabled"></a-textarea>
              </a-form-model-item>
               <!---所属领域-->
<!--              <a-form-model-item  :label="this.language['application.realm']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="orgIds" >
                <a-select v-model="model.orgIds" allowClear @change="updateOrg"    mode="multiple" :placeholder="this.language['application.realm.desc']" >
                  <a-select-option v-for="(org,index) in orgList" :key="index.toString()" :value="org.id">
                    {{ org.portalOrgName }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>-->
              <a-form-model-item aria-label="員工入口" :label="this.language['emp.develop.empEntrance']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="entranceList">
                <a-checkbox-group v-model="model.entranceList" @change="handleChangeEntrance" :disabled="formDisabled" >
                  <!--                <div v-for="(item,index) in entranceOptions" :key="index">-->
                  <a-checkbox v-for="(item,index) in entranceOptions" :key="index" :value="item.value" >{{item.label}}</a-checkbox>
                  <!--                </div>-->
                </a-checkbox-group>
              </a-form-model-item>

              <div v-for="(item,index) in selectedEntrances" :key="index">
                <a-form-model-item aria-label="应用分类" :label="language['emp.develop.appType']+cale(item)"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select show-search :placeholder="language['column.pleaseChoose']+language['emp.develop.appType']"
                            :disabled="formDisabled" v-model="appData[index]" >

                    <a-select-option v-for="(item1,index) in apptypeOptions.filter(temp => temp.entranceId === item)" :key="index" :value="item1.value" allowClear >
                      {{ item1.label }}
                    </a-select-option>
                  </a-select>
                  <!--              <Component :modelValue="inputValue" @update:modelValue="updateValue" />-->

                </a-form-model-item>
              </div>
              <!--联系人-->
              <a-form-model-item  :label="this.language['portal.ui2.appContacts']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="contactUser" >
                <a-input v-model="model.contactUser"  max-Length="64" :disabled="formDisabled"></a-input>
              </a-form-model-item>
              <!--联系方式-->
              <a-form-model-item  :label="this.language['portal.ui2.appContactInfo']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="contactMode" >
                <a-input v-model="model.contactMode"  max-Length="64" :disabled="formDisabled"></a-input>
              </a-form-model-item>
              <a-form-model-item :label="language['portal.ui2.appContactUs']" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                <div >
                  <a-row v-for="(item,index) in contactList" :key="index">
                    <a-col :span="6">
                      <a-input v-model="item.contactName" :placeholder="language['emp.content.model6.contacts']" max-Length="100" />
                    </a-col>
                    <a-col :span="6">
                      <a-input v-model="item.contactPhone" :placeholder="language['emp.content.model6.contactsPhone']" max-Length="100" style="margin-left: 5px;"/>
                    </a-col>
                    <a-col :span="6">
                      <a-input v-model="item.contactEmail" :placeholder="language['emp.content.model6.contactsMail']" max-Length="100" style="margin-left: 10px;"/>
                    </a-col>
                    <a-col :span="6">
                      <a @click="removeContact(item)" v-if="contactList.length>1" style="margin-left: 20px;">{{language['common.delete']}}</a>
                    </a-col>
                  </a-row>
                </div>
                <a @click="addContact" >{{language['showroom.order.btn.add']}}</a>
              </a-form-model-item>


              <a-form-model-item :label="language['application.applicationStatus']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="applicationStatus">
                  <j-dict-select-tag  v-model="model.applicationStatus"  :type="'radio'" dictCode="application_status" :disabled="formDisabled"/>
                </a-form-model-item>
                <a-form-model-item
                  :label="language['application.applicationType']"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  prop="applicationType">
                  <j-dict-select-tag v-model="model.applicationType" :allowClear="true" dictCode="application_type" :disabled="formDisabled"/>
                </a-form-model-item>
              <a-form-model-item
                :label="language['application.opentype']"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                prop="openType">
                <j-dict-select-tag  v-model="model.openType"  :type="'radio'" dictCode="open_type" :disabled="formDisabled"/>
              </a-form-model-item>
              <a-form-model-item
                :label="language['application.netFlag']"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                prop="netFlag">
                <j-dict-select-tag  v-model="model.netFlag"  :type="'radio'" dictCode="net_flag" :disabled="formDisabled"/>
              </a-form-model-item>
              <a-form-model-item
                :label="language['application.encryType']"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                prop="encryType">
                <j-dict-select-tag  v-model="model.encryType"  :type="'radio'" dictCode="encry_type" :disabled="formDisabled"/>
              </a-form-model-item>
                <a-form-model-item :label="language['application.thirdFlag']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="thirdFlag">
                  <j-dict-select-tag  v-model="model.thirdFlag"  :type="'radio'" dictCode="third_flag" :disabled="formDisabled"/>
                </a-form-model-item>
              <a-form-model-item :label="language['portal.third.party.review']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="thirdCheck" >
                <j-dict-select-tag  v-model="model.thirdCheck"  :type="'radio'" dictCode="third_flag" :disabled="formDisabled" />
              </a-form-model-item>
              <a-form-model-item :label="language['portal.third.party.review']+'Url'"  :labelCol="labelCol" :wrapperCol="wrapperCol" v-show="!this.thridCheckUrldisable">
                <a-input v-model="model.thirdCheckUrl"  max-Length="64" :disabled="thridCheckUrldisable" ></a-input>
              </a-form-model-item>
                <a-form-model-item :label="language['application.ssoFlag']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="ssoFlag">
                  <j-dict-select-tag  v-model="model.ssoFlag"  :type="'radio'" dictCode="sso_flag" :disabled="formDisabled"/>
                </a-form-model-item>



                <a-form-model-item :label="language['application.applicationImgPath']" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <j-image-upload class="avatar-uploader" :text="language['common.uploadButton']" v-model="model.applicationImgPath" :upload-source="uploadSource" :disabled="formDisabled"></j-image-upload>
                </a-form-model-item>
                <a-form-model-item
                  :label="language['application.siteType']"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  prop="qrcodeFlag">
                  <j-dict-select-tag  v-model="model.qrcodeFlag"  :type="'radio'" dictCode="site_type" :disabled="formDisabled"/>
                </a-form-model-item>
              <a-form-model-item :label="language['application.applicationUrl']" :labelCol="labelCol" :wrapperCol="wrapperCol" v-show="model.qrcodeFlag === '0'">
                  <a-input v-model="model.applicationUrl"  max-Length="255" :disabled="formDisabled"></a-input>
                </a-form-model-item>

              <a-form-model-item
                :label="language['application.urlType']"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                prop="urlType" v-show="model.qrcodeFlag == '1'">
                <j-dict-select-tag  v-model="model.urlType"  :type="'radio'" dictCode="url_type" :disabled="formDisabled"/>
              </a-form-model-item>

              <a-form-model-item :label="language['application.qrcodeGen']" :labelCol="labelCol" :wrapperCol="wrapperCol"  v-show="model.qrcodeFlag == '1'&&model.urlType == '1'">
                <j-image-upload class="avatar-uploader" :text="language['common.uploadButton']" v-model="model.qrcodeImgPath" :upload-source="uploadSource" :disabled="formDisabled"></j-image-upload>
              </a-form-model-item>
              <a-form-model-item :label="language['application.h5Url']" :labelCol="labelCol" :wrapperCol="wrapperCol" v-show="model.qrcodeFlag == '1'&&model.urlType == '0'">
                <a-input v-model="model.h5Url"  max-Length="255" :disabled="formDisabled"></a-input>
              </a-form-model-item>
              <a-form-model-item :label="language['application.textDesc']" :labelCol="labelCol" :wrapperCol="wrapperCol" v-show="model.qrcodeFlag == '1'">
                <a-input v-model="model.urlDesc"  max-Length="255" :disabled="formDisabled"></a-input>
              </a-form-model-item>

              <a-form-model-item :label="language['application.management.unit']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="managementUnit">
                  <a-input v-model="model.managementUnit" :disabled="formDisabled"></a-input>
                </a-form-model-item>
                <a-form-model-item :label="language['basedata.remark']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="remark">
                  <a-textarea v-model="model.remark" :placeholder="language['common.pleaseInput']+language['basedata.remark']" :maxLength="500" :disabled="formDisabled"></a-textarea>
                </a-form-model-item>
            </a-form-model>
          </j-form-container>
        </a-tab-pane>
        <a-tab-pane loading="true" :tab="tabName2" key="2" forceRender="true">
          <j-form-container  >
            <a-form-model  ref="form1" :model="details" :rules="validatorRules" slot="detail">
              <a-row :gutter="24">
                <a-col :span="12">
                <a-checkbox-group style="display: flex;flex-direction: column;align-items: left;" @change="languageSettingsChange" v-model="languageSettings" :disabled="formDisabled">
<!--                  <a-row :gutter="24">
                    <p :style="{ marginBottom: '20px',paddingLeft: '20px',}" :span="8">
                      <a-checkbox value="A">简体中文 </a-checkbox>
                    </p>
                    <p :style="{ marginBottom: '20px',paddingLeft: '20px',}" :span="8">
                      <a-checkbox value="B">繁体中文 </a-checkbox>
                    </p>
                    <p :style="{ marginBottom: '20px',paddingLeft: '20px',}" :span="8">
                      <a-checkbox value="C">英文 </a-checkbox>
                    </p>
                  </a-row>-->
                  <a-row :gutter="24">
                    <a-col v-for="(item,index) in allLanguageTemplate" :key="index" :span="8" style="padding-bottom: 12px;">
                      <a-checkbox :value="item.value">{{language[item.langKey]}} </a-checkbox>
                    </a-col>
<!--                    <a-col :span="8" style="padding-bottom: 12px;">
                      <a-checkbox value="A2">简体中文2 </a-checkbox>
                    </a-col>
                    <a-col :span="8" style="padding-bottom: 12px;">
                      <a-checkbox value="B2">繁体中文2 </a-checkbox>
                    </a-col>
                    <a-col :span="8" style="padding-bottom: 12px;">
                      <a-checkbox value="C2">英文2 </a-checkbox>
                    </a-col>

                    <a-col :span="8" style="padding-bottom: 12px;">
                      <a-checkbox value="C21">英文21 </a-checkbox>
                    </a-col>-->
                  </a-row>
                </a-checkbox-group>
                </a-col>
                <a-col :span="12">
                  <j-editable-table
                    ref="sortTable"
                    rowNumber
                    dragSort
                    :columns="columns"
                    :dataSource="dataSource"
                    :sortInsertDown="false"
                  />
                </a-col>
              </a-row>
            </a-form-model>
          </j-form-container>
        </a-tab-pane>
        <a-tab-pane loading="true" :tab="tabName3" key="3" forceRender="true">
          <j-form-container  >
            <a-form-model  ref="form2" :model="details" :rules="validatorRules" slot="detail">
              <a-form-model-item :label="language['application.isRegisterApplication']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop=""><!--`注册应用`-->
                <j-dict-select-tag @change="registerChange" v-model="details.isRegisterApplication"  :type="'radio'" dictCode="register_flag" :disabled="formDisabled"/>
              </a-form-model-item>
              <div v-if="details.isRegisterApplication == '1'">
              <a-form-model-item :label="language['application.applicationKey']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="applicationKey"><!--`应用key`-->
                <a-input v-model="details.applicationKey"  max-Length="60" :disabled="formDisabled"></a-input>
                <!--<a-row type="flex" :gutter="8">
                  <a-col class="left">
                    <a-input v-model="details.applicationKey"  max-Length="64" readOnly style="background-color: whitesmoke;"></a-input>
                  </a-col>
                  <a-col  class="right">
                    <a-button type="primary"  :disabled="formDisabled" @click="refreshData">刷新</a-button>
                  </a-col>
                </a-row>-->
              </a-form-model-item>
              <a-form-model-item :label="language['application.applicationSecret']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="applicationSecret"><!--`应用Secret`-->
                <a-row type="flex" :gutter="8">
                  <a-col class="left">
                  <a-input v-model="details.applicationSecret"  max-Length="64" readOnly style="background-color: whitesmoke;" ></a-input>
                  </a-col>
                  <a-col class="right">
                    <a-button type="primary"  :disabled="formDisabled" @click="refreshData" >{{language['common.refresh']}}</a-button>
                  </a-col>
                </a-row>
              </a-form-model-item>
              <a-form-model-item :label="language['application.urls']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop=""><!--`可用接口(多个用;分割)`-->
                <a-textarea v-model="details.urls" rows="5" max-Length="2000" :disabled="formDisabled"></a-textarea>
              </a-form-model-item>
              </div>

            </a-form-model>
          </j-form-container>
        </a-tab-pane>
      </a-tabs>
    <language-model ref="languageModel" @ok="languageOk"></language-model>
  </a-spin>
</template>

<script>

  import {httpAction, getAction,postAction,putAction} from '@/api/manage'
  import {validateDuplicateValue} from '@/utils/util'
  import { duplicateCheck } from '@/api/api'
  import LanguageModel from "@/components/LanguageModel"


  export default {
    name: 'SysBmApplicationForm',
    components: {LanguageModel},
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data() {
      return {
        columns:[
          {
            title: 'langcode',
            width: '80px',
            key: 'langCode',
            dataIndex: 'langCode'
          },
          {
            title: '语言值',
            width: '80px',
            key: 'langName',
            dataIndex: 'langName'
          },
        ],
        dataSource:[],
        tabName1: this.$store.getters.language['application.message'],//应用信息
        tabName2: this.$store.getters.language['application.LanguageSettings'],//应用语言
        // languageSettings:"zh_CN,zh_TW",
        languageSettings:[],
        allLanguageTemplate:[],
        tabName3: this.$store.getters.language['application.interface'],//应用接口
        model: {
          orgIds: []
        },
        orgList: [],
        details: {
          isRegisterApplication: '',
          applicationKey: '',
          applicationSecret: '',
          urls: '',
        },
        labelCol: {
          xs: {span: 24},
          sm: {span: 5},
        },
        wrapperCol: {
          xs: {span: 24},
          sm: {span: 16},
        },
        confirmLoading: false,
        uploadSource: "platform",
        /*validatorRules: {
          applicationName: [
            {required: true, message: this.language['application.applicationNamePh']},
          ],
          applicationCode: [
            {required: true, message: this.language['application.applicationCodePh']},
            { validator: this.validateApplicationCode }
          ],
          applicationStatus: [
            {required: true, message: this.language['application.applicationStatusPh']},
          ],
          applicationType: [
            {required: true, message: this.language['application.applicationTypePh']},
          ],
        },*/
        url: {
          add: "/sys/sysBmApplication/add",
          edit: "/sys/sysBmApplication/edit",
          queryById: "/sys/sysBmApplication/queryById",
          entranceList: "/hhemp/entrance/empcmsentrances?status=Y",
          apptypeList: "/hhemp/apptype/empbaseapptypes2?publishStatus=up&pageNo=1&pageSize=10000",
        },
        applicationNameLanguages: [],
        applicationDescLanguages: [],
        thridCheckUrldisable: true,
        entranceOptions:[],
        selectedEntrances:[],
        apptypeOptions:[],
        appData:[],
        contactList: [],
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      validatorRules() {
        if (this.language) {
          return {
            applicationKey: [
              {required: true, message: this.language['application.applicationKeyNotNull']},//'应用Key不能为空'
              {validator: this.validateApplicationKey}
            ],
            functionDesc: [
              {
                required: true,
                message: this.language['portal.ui2.appMajorFunction'] + this.language['common.cannotEmpty']
              },
              {
                min: 2,
                max: 500,
                message: this.language['common.lengthRange'] + ' 2 ' + this.language['common.to'] + ' 500 ' + this.language['common.character'],
                trigger: 'blur'
              },
            ],
            contactUser: [
              {
                min: 2,
                max: 100,
                message: this.language['common.lengthRange'] + ' 2 ' + this.language['common.to'] + ' 100 ' + this.language['common.character'],
                trigger: 'blur'
              },
            ],
            contactMode: [
              {
                min: 2,
                max: 255,
                message: this.language['common.lengthRange'] + ' 2 ' + this.language['common.to'] + ' 255 ' + this.language['common.character'],
                trigger: 'blur'
              },
            ],
            /*orgIds: [
            {required: true, message: ""},
          ],*/
            applicationSecret: [
              {required: true, message: this.language['application.applicationSecretNotNull']},//'应用Secret不能为空'
            ],
            applicationName: [
              {required: true, message: this.language['application.applicationNamePh']},
            ],
            applicationCode: [
              {required: true, message: this.language['application.applicationCodePh']},
              {validator: this.validateApplicationCode}
            ],
            applicationStatus: [
              {required: true, message: this.language['application.applicationStatusPh']},
            ],
            applicationType: [
              {required: true, message: this.language['application.applicationTypePh']},
            ],
            thirdFlag: [
              {required: true, message: this.language['application.thirdFlagPh']},
            ],
            thirdCheck: [
              {required: true, message: this.language['application.thirdCheckPh']},
            ],
            ssoFlag: [
              {required: true, message: this.language['application.ssoFlagPh']},
            ],
            openType: [
              {required: true, message:  this.language['common.pleaseChoose'] + this.language['application.opentype'] },
            ],
            netFlag: [
              {required: true, message:  this.language['common.pleaseChoose'] + this.language['application.netFlag'] },
            ],
            encryType: [
              {required: true, message:  this.language['common.pleaseChoose'] + this.language['application.encryType'] },
            ],
            qrcodeFlag: [
              {required: true, message:  this.language['common.pleaseChoose'] + this.language['application.siteType'] },
            ],
            managementUnit: [
              {
                required: true,
                message: this.language['application.management.unit'] + this.language['common.cannotEmpty']
              },
              {min: 0, max: 100, message: '长度不超过 100 个字符', trigger: 'blur'},
            ]
          }
        }
      },
      formDisabled() {
        return this.disabled
      },
    },

    created() {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
      //this.initOrgList();
      this.initallLanguageTemplate();
      this.initEntranceList();
      this.initApptypeList();
      /*this.selectedEntrances = this.model.entranceList || [];
      this.appData = this.model.appTypeList || [];
      this.entranceId = this.model.entranceList || [];*/

    },

    methods: {
      languageSettingsChange(v){
        this.initlanguageTable(this.languageSettings)
      },
      initallLanguageTemplate(){
        getAction("/sys/dictItem/languageTemplate",{dictCode:'system_language_template'}).then(res=>{
          if(res.success){
            this.allLanguageTemplate = res.result
            this.initlanguageTable(this.languageSettings)
          }
        })
      },
      thridCheckChange(value) {
        if (value == 1) {
          this.thridCheckUrldisable = false;
        } else {
          this.thridCheckUrldisable = true;
        }
      },
      updateOrg() {
        this.$forceUpdate();
      },
      languageModelOpen(dataTable, dataColumn, languagelist) {
        console.log("this.model.id：",this.model.id)
        this.$refs.languageModel.edit("platform", dataTable, dataColumn, this.model.id, languagelist, this.disabled);
      },
      languageOk(map) {
        if (map && map.dataColumn == 'applicationName') {
          this.applicationNameLanguages = map.languagelist;
        } else if (map && map.dataColumn == 'applicationDesc') {
          this.applicationDescLanguages = map.languagelist;
        }
      },
      initOrgList() {
        getAction("/sys/portal/sysPortalOrg/listNotPages", {}).then((res) => {
          if (res.success) {
            console.log(res);
            this.orgList = res.result;
          }
        })
      },
      initOrgByApp(appId) {
        getAction("/sys/portal/sysPortalOrgApplication/queryListByApp", {appId: appId}).then((res) => {
          if (res.success) {
            // console.log(res);
            let list = res.result;
            this.model.orgIds = [];
            for (let i = 0; i < list.length; i++) {
              this.model.orgIds[i] = list[i].portalOrgId;
            }

            //console.log("this.model.orgIds",this.model.orgIds);
            this.$forceUpdate();
          }
        })
      }
      ,
      initLanguagetemp(dataTable, dataColumn, dataId) {
        getAction("/sys/syslanguagedata/querylistby", {
          applicationCode: "platform",
          dataTable: dataTable,
          dataColumn: dataColumn,
          dataId: dataId
        }).then((res) => {
          if (res.success) {
            if (dataColumn == 'applicationName') {
              this.applicationNameLanguages = res.result;
            } else if (dataColumn == 'applicationDesc') {
              this.applicationDescLanguages = res.result;
            }
          }
        })
      },
      validateApplicationKey(rule, value, callback) {
        if (/[\u4E00-\u9FA5]/g.test(value)) {
          let data = this.language['common.front.apply.cannot.chinese'];
          console.log(data);
          callback(new Error(data));
        } else {
          let that = this;
          let params = {
            tableName: 'sys_bm_application_details',
            fieldName: 'application_key',
            fieldVal: value,
            dataId: this.details.id,
          };
          duplicateCheck(params).then((res) => {
            if (res.success) {
              callback()
            } else {
              callback(this.language['application.applicationSecret'] + this.language['common.alreadyExists'])
            }
          })

        }
      },
      refreshData() {
        putAction("/sys/thirdApplicaiton/sysbmapplicationdetails/refreshSecret").then((res) => {
          if (res.success) {
            let secret = res.result;
            this.details.applicationSecret = secret;
          }
        })
      },
      registerChange(e) {

      },
      changeTabs(activeKey) {
        if (activeKey === 2) {
          // this.initModel(this.model.applicationCode);
        } else if (activeKey === 1) {
        }
      },
      validateApplicationCode(rule, value, callback) {
        // 重复校验
        let params = {
          tableName: 'sys_bm_application',
          fieldName: 'application_code',
          fieldVal: value,
          dataId: this.model.id
        };
        duplicateCheck(params).then((res) => {
          if (res.success) {
            callback()
          } else {
            callback(res.message)
          }
        })
      },

      add() {
        this.edit(this.modelDefault);
        this.initContactList();
      }
      ,
      edit(record) {
        this.model = Object.assign({}, record);
        this.initModel(this.model.applicationCode);
        this.initLanguagetemp('SysBmApplication', 'applicationName', record.id)
        this.initLanguagetemp('SysBmApplication', 'applicationDesc', record.id)
        if (record.hasOwnProperty("id")) {
          this.initOrgByApp(record.id);
          this.initEditContactList(record.contactInfo);
        }
        if(!!record.languageSettings){
          this.languageSettings = record.languageSettings.split(",")
        }
        this.selectedEntrances = this.model.entranceList || [];
        this.appData = this.model.appTypeList || [];
        this.entranceId = this.model.entranceList || [];
        this.model.entranceList = this.entranceId;
        this.visible = true;
      },
      initlanguageTable(languageSettings){
        this.dataSource = [];
        let list = this.allLanguageTemplate;
        for(let i=0;i<languageSettings.length;i++){
          let languageValue = languageSettings[i];
          for(let j=0;j<list.length;j++){
            let templateItem = list[j];
            if(templateItem.value == languageValue){
              this.dataSource.push({'langCode':templateItem.value,'langName':templateItem.text})
              break;
            }
          }
        }
      },
      initModel(applicationCode) {
        getAction("/sys/thirdApplicaiton/sysbmapplicationdetails/" + applicationCode).then((res) => {
          if (res.success) {
            this.details = res.result;
            // this.model.details.urls = res.result.interfaceList
            /*let urllist = res.result.interfaceList
            if(urllist){
              let urls = "";
              urllist.forEach(item=>{
                urls = urls + item.interfaceUrl+";"
              })
              this.details.urls = urls;
            }*/
          }
        })
      },
      saveDetails(modelData) {
        let data = this.details;
        data.applicationId = modelData.id;
        data.applicationCode = this.model.applicationCode
        putAction("/sys/thirdApplicaiton/sysbmapplicationdetails", data).then((res) => {
          if (res.success) {
            let list = []
            this.applicationNameLanguages.forEach(item => {
              if (!item.dataId) {
                item.dataId = modelData.id;
              }
              list.push(item);
            })
            this.applicationDescLanguages.forEach(item => {
              if (!item.dataId) {
                item.dataId = modelData.id;
              }
              list.push(item);
            })
            httpAction("/sys/syslanguagedata/saveSysLanguageDataList", list, "post").then((res) => {
              if (res.success) {
                this.$message.success(res.message);
                this.$emit('ok');
                this.confirmLoading = false;
              }
            })
          } else {
            this.$message.warning(res.message);
            this.confirmLoading = false;
          }
        })
      },
      submitForm() {
        const that = this;
        // 触发表单验证
        //  console.log("this.model.orgIds",this.model.orgIds);
        //  return;

        /*this.$refs.form2.validate(valid => {
          if(valid){
            that.$message.warning(that.language['application.interface'] + that.language['ipsys.notFilledIn'] + '!');
          }else{
            return false;
          }
        });*/
        this.$refs.form.validate(valid => {


          if (valid) {
            /*if (that.model.orgIds.length == 0) {
              that.$message.warning(that.language['application.realm'] + that.language['common.cannotEmpty']);
              return;
            }*/

            that.model.appTypeList = that.appData;
            if(that.model.entranceList.length!=that.model.appTypeList.length){
              that.$message.warning(that.language['common.pleaseChoose'] + that.language['emp.develop.appType'] + '!');
              return false;
            }

            /*this.$refs.detailsValidForm.validate(detailsValid => {
              if(detailsValid){*/
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.id) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'put';
            }
            if(this.languageSettings.length>0){
              // this.model.languageSettings = this.languageSettings.join(",");
              let list = this.$refs.sortTable.getValuesSync({ validate: false }).values
              let str = "";
              list.forEach(item=>{
                if(str==''){
                  str = str+item.langCode;
                }else{
                  str = str+","+item.langCode;
                }
              })
              that.model.languageSettings = str;
              /*let str = "";
              that.dataSource.forEach(item=>{
                if(str==''){
                  str = str+item.langCode;
                }else{
                  str = str+","+item.langCode;
                }
              })
              that.model.languageSettings = str;*/
            }

            let contactData = that.contactList.filter(item =>
              Object.keys(item).some(key =>
                key.startsWith('contact') &&
                item[key] &&
                item[key].trim()
              )
            );
            this.model.contactInfo = JSON.stringify(contactData);

            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                this.saveDetails(res.result);
                /*that.$message.success(res.message);
                    that.$emit('ok');*/
              } else {
                that.$message.warning(res.message);
                that.confirmLoading = false;
              }
            })
            /*}
              else{
                this.$message.warning('applicationKey不能为空');
              }

            })*/

          } else {
            // let str = "";
            // for(var key in data) {
            //   var value = data[key];
            //   if(str == ''){
            //     str = value[0].message;
            //   }else{
            //     str = str + ',' +value[0].message;
            //   }
            // }
            // this.$message.warning(str);
          }

        })
      },
      //初始化入口列表
      initEntranceList(){
        getAction(this.url.entranceList).then(res=>{
          if(res.success){
            this.entranceOptions = res.result.map((item,index,arr)=>{
              let c = {label:item.entranceName, value: item.id+""}
              return c;
            })
          }
        })
      },
      //初始化应用分类列表
      initApptypeList(){
        getAction(this.url.apptypeList).then(res=>{
          if(res.success){
            this.apptypeOptions = res.result.records.map((item,index,arr)=>{
              let c = {label:item.appTypeName, value: item.id+"",entranceId: item.entranceId}
              return c;
            })
          }
        })
      },
      handleChangeEntrance(event){
        this.selectedEntrances = event;
        this.entranceId = event;
        this.model.entranceList = event;

        for(let i = this.appData.length - 1; i >= 0 && this.appData.length>this.selectedEntrances.length; i--){
          if(this.appData.length>this.selectedEntrances.length){
            this.appData.splice(i, 1);
          }
        }
        let appDataNew = [];
        for (let i = 0; i<this.selectedEntrances.length; i++) {
          // 获取当前下标对应的值
          const index = this.selectedEntrances[i];
          const appTypeListTemp =  this.apptypeOptions.filter(temp => temp.entranceId === index);

          for(let j=0;j<appTypeListTemp.length;j++) {
            if (this.appData.length>j-1 && this.appData[i] == appTypeListTemp[j].value) {
              appDataNew.push(appTypeListTemp[j].value)
              break;
            }
          }

        }
        this.appData = appDataNew;

      },
      cale(temp){
        const foundItem = this.entranceOptions.find(item => item.value === temp);
        return  foundItem ? '('+foundItem.label+')' : '';
      },
      initContactList(){
        this.contactList = [{dataType:'contact',applicationId:this.model.id,sort:0}];
      },
      addContact(){
        let data = this.getContactMaxSort();
        this.contactList.push({dataType:'contact',applicationId:this.model.id,sort:data?(data.sort+1):0})
      },
      getContactMaxSort() {
        // 使用.reduce来找到具有最大sort的对象
        return this.contactList.reduce((max, item) => {
          return item.sort > max.sort ? item : max;
        }, this.contactList[0]); // 初始值设置为数组的第一个元素，确保总是有一个比较的对象
      },
      removeContact(data){
        this.contactList.splice(this.contactList.findIndex(item => item.sort === data.sort), 1);
      },
      initEditContactList(contactInfo){
        let contentInfos = JSON.parse(contactInfo);
        if(contentInfos&&contentInfos.length>0){
          this.contactList = contentInfos;
        }else{
          this.initContactList();
        }

      },
    },
    watch: {
      'model.thirdCheck'(newValue, preValue) {
        console.log("model---:",newValue,preValue)
        this.thridCheckChange(newValue);
      }
    }
  }
</script>
<style lang="less" scoped>

  .left {
    width: calc(100% - 72px - 8px);
  }

  .right {
    width: 72px;
  }
</style>